export const LegalConstitutionType = (classOfCompanyKey) => {
    let classOfCompanyMap = new Map([
        ['Proprietorship', 'Proprietorship'],
        ['Partnership', 'Partnership'],
        ['LLP', 'LLP'],
        ['Private Limited', 'PrivateLimited'],
        ['Public Listed', 'PublicListed'],
        ['Public Unlisted', 'PublicUnlisted'],
        ['Others', 'Others']
    ]);

    let classOfCompanyMapped = [];
    classOfCompanyKey.forEach(data => {
        classOfCompanyMapped.push(classOfCompanyMap.get(data))
    });
    return classOfCompanyMapped;
}